class PaymentWorldpayController {
  constructor ($log, UserService, PaymentService, VehicleService, ProductService, $window, $state) {
    'ngInject'
    this.userService = UserService
    this.paymentService = PaymentService
    this.vehicleService = VehicleService
    this.productService = ProductService
    this.$window = $window
    this.$state = $state
    this.$log = $log
    this.getWallet()
    this.getWorldpayTokenisableMeansOfPayments()
    this.getWorldpayNoTokenisableMeansOfPayments()
    this.isProcessing = false
  }

  getWallet () {
    return this.userService.getWallet()
    .then((res) => {
      this.error = null
      this.walletWorldpay = res.cards
    }, (err) => {
      this.validForm = false
      this.error = err
    })
  }

  getWorldpayTokenisableMeansOfPayments () {
    return this.paymentService.getWorldpayMeansOfPayments(true)
    .then((res) => {
      this.error = null
      this.$log.debug('getWorldpayTokenisableMeansOfPayments', res)
      this.meansTokenisable = res
    }, (err) => {
      this.validForm = false
      this.error = err
    })
  }

  getWorldpayNoTokenisableMeansOfPayments () {
    return this.paymentService.getWorldpayMeansOfPayments(false)
    .then((res) => {
      this.error = null
      this.$log.debug('getWorldpayNoTokenisableMeansOfPayments', res)
      this.meansNoTokenisable = res
    }, (err) => {
      this.validForm = false
      this.error = err
    })
  }

  directPaymentSubmit () {
    this.isProcessing = true
    this.purchaseInfos.isFreeProduct = false
    this.purchaseInfos.paymentId = this.cardId
    this.purchaseInfos.sessionId = 'sessionId' // TODO - à modifier par la suite
    const vin = this.vehicleService.getCurrentVin()
    return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos)
    .then((res) => {
      this.isProcessing = false
      // MAJ SessionStorage
      if (this.purchaseInfos.isPro) {
        this.userService.setCurrentCompany(this.purchaseInfos.buyer.company)
      }
      this.$state.go('managePurchase.confirmation', {productId: this.productRef, free: false, status: res.pspPaymentStatus, voucher: this.voucherInfos.isPurchaseUsingVoucher, reduction: this.voucherInfos.amountReduction, direct: true})
    }, (err) => {
      this.isProcessing = false
      this.errorPurchase = {
        message: 'error.' + err.data.meta.code,
        cause: err
      }
      this.$log.debug('buyProduct directPayment worldpay error', err)
    })
  }

  redirectPaymentTokenisableSubmit () {
    this.isProcessing = true
    this.purchaseInfos.isFreeProduct = false
    this.purchaseInfos.paymentMethod = this.selectedMeansTokenisable
    this.purchaseInfos.createToken = this.saveCard
    const vin = this.vehicleService.getCurrentVin()
    return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos)
    .then((res) => {
      this.isProcessing = false
      // MAJ SessionStorage
      if (this.purchaseInfos.isPro) {
        this.userService.setCurrentCompany(this.purchaseInfos.buyer.company)
      }
      this.$window.open(res.pspUrl, '_self')
    }, (err) => {
      this.isProcessing = false
      this.errorPurchase = {
        message: 'error.' + err.data.meta.code,
        cause: err
      }
      this.$log.debug('buyProduct redirectPaymentTokenisable worldpay error', err)
    })
  }

  redirectPaymentNoTokenisableSubmit () {
    this.isProcessing = true
    this.purchaseInfos.isFreeProduct = false
    this.purchaseInfos.paymentMethod = this.selectedMeansNoTokenisable
    const vin = this.vehicleService.getCurrentVin()
    return this.productService.buyProduct(vin, this.productRef, this.purchaseInfos, this.voucherInfos)
    .then((res) => {
      this.isProcessing = false
      // MAJ SessionStorage
      if (this.purchaseInfos.isPro) {
        this.userService.setCurrentCompany(this.purchaseInfos.buyer.company)
      }
      this.$window.open(res.pspUrl, '_self')
    }, (err) => {
      this.isProcessing = false
      this.errorPurchase = {
        message: 'error.' + err.data.meta.code,
        cause: err
      }
      this.$log.debug('buyProduct redirectPaymentNoTokenisable worldpay error', err)
    })
  }

  blockTokenisableControl () {
    if (this.paymentNoTokenisable === true) {
      this.paymentNoTokenisable = !this.paymentNoTokenisable
    }
    this.paymentTokenisable = !this.paymentTokenisable
  }

  blockNoTokenisableControl () {
    if (this.paymentTokenisable === true) {
      this.paymentTokenisable = !this.paymentTokenisable
    }
    this.paymentNoTokenisable = !this.paymentNoTokenisable
  }

  controlCheckDirectPayment () {
    if (this.cardId) {
      this.selectedMeansNoTokenisable = undefined
      this.selectedMeansTokenisable = undefined
      this.saveCard = undefined
    }
  }

  controlCheckTokenisable () {
    if (this.selectedMeansTokenisable) {
      this.selectedMeansNoTokenisable = undefined
      this.cardId = undefined
    }
  }

  controlCheckNoTokenisable () {
    if (this.selectedMeansNoTokenisable) {
      this.cardId = undefined
      this.selectedMeansTokenisable = undefined
      this.saveCard = undefined
    }
  }

  goBack () {
    this.$window.history.back()
  }
}
export default PaymentWorldpayController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-worldpay/payment-worldpay.controller.js